import { Image, View, YStack } from "tamagui";
import { Linking } from "react-native";

type RouteCardProps = {
  strava_id: string;
  image_url?: string;
};
export const RouteCard = ({ strava_id, image_url }: RouteCardProps) => {
  console.log(image_url);
  return (
    <YStack
      w="100%"
      onPress={() => Linking.openURL(`https://strava.com/routes/${strava_id}`)}
    >
      <View width={"100%"}>
        <View w="100%" overflow="hidden" pos="relative">
          <Image
            source={{ uri: image_url ?? "" }}
            w="100%"
            aspectRatio={2 / 1}
          />
        </View>
      </View>
    </YStack>
  );
};
